export const PAGE_KEYS = {
    MARKETPLACE_LOGGED_IN_HOME: 'discovery_logged_in_home',
    PERSONAL_PLAN_LOGGED_IN_HOME: 'personal_plan_logged_in_home',
};
